import { loadScenario } from "../../../engine/lesson/scenario";
import sandboxJson from "./sandbox.json";
import howThisLabWorksJson from "./how-this-lab-works.json";
import labTourJson from "./lab-tour.json";
import readingTheCloudJson from "./reading-the-cloud.json";
import readingCuesJson from "./reading-cues.json";
import readingInfoPanelJson from "./reading-info-panel.json";
import summonAndBenchRulesJson from "./summon-and-bench-rules.json";
import moleculeViewerTourJson from "./molecule-viewer-tour.json";
import reactionRulesQuickJudgmentJson from "./reaction-rules-quick-judgment.json";
import reactionRulesPrecipitationJson from "./reaction-rules-precipitation.json";
import reactionRulesGasEvolutionJson from "./reaction-rules-gas-evolution.json";
import reactionRulesDisplacementJson from "./reaction-rules-displacement.json";
import reactionRulesComplexJson from "./reaction-rules-complex.json";
import reactionRulesAmphotericJson from "./reaction-rules-amphoteric.json";
import reactionRulesRedoxJson from "./reaction-rules-redox.json";
import reactionRulesDecompositionJson from "./reaction-rules-decomposition.json";
import gasTestsJson from "./gas-tests.json";
import gasPlumbingDemoJson from "./gas-plumbing-demo.json";
import gasCylinderCl2KiJson from "./gas-cylinder-cl2-ki.json";
import naohHandlingJson from "./naoh-handling.json";
import titrationHclNaohJson from "./titration-hcl-naoh.json";
import mgAcidFizzJson from "./mg-acid-fizz.json";
import dissolvingSaltJson from "./dissolving-salt.json";
import carbonateAcidJson from "./carbonate-acid.json";
import halideTestJson from "./halide-test.json";
import colorMixingJson from "./color-mixing.json";
import evaporationJson from "./evaporation.json";
import dilutionJson from "./dilution.json";
import naohExothermicJson from "./naoh-exothermic.json";
import nh4no3EndothermicJson from "./nh4no3-endothermic.json";
import singleReplacementZnCuJson from "./single-replacement-zn-cu.json";
import copperHydroxidePrecipitationJson from "./copper-hydroxide-precipitation.json";
import ironHydroxidePrecipitationJson from "./iron-hydroxide-precipitation.json";
import h2o2DecompositionJson from "./h2o2-decomposition.json";
import pbi2PrecipitationJson from "./pbi2-precipitation.json";
import mgH2so4Json from "./mg-h2so4.json";
import bariumSulfatePrecipitationJson from "./barium-sulfate-precipitation.json";
import copperSilverTreeJson from "./copper-silver-tree.json";
import acidBaseNeutralizationJson from "./acid-base-neutralization.json";
import stoichiometryMgHclJson from "./stoichiometry-mg-hcl.json";
import massBalanceCuAgJson from "./mass-balance-cu-ag.json";
import equilibriumFeScnJson from "./equilibrium-fe-scn.json";
import weakVsStrongAcidJson from "./weak-vs-strong-acid.json";
import commonIonEffectJson from "./common-ion-effect.json";
import bufferDemoJson from "./buffer-demo.json";
import redoxTitrationPermanganateJson from "./redox-titration-permanganate.json";
import catalysisH2o2Mno2Json from "./catalysis-h2o2-mno2.json";
import chromateDichromateJson from "./chromate-dichromate.json";
import indicatorsComparisonJson from "./indicators-comparison.json";
import limitingReagentMgHclJson from "./limiting-reagent-mg-hcl.json";
import singleReplacementFeCuJson from "./single-replacement-fe-cu.json";
import reactivitySeriesJson from "./reactivity-series.json";
import dilutionCalculationJson from "./dilution-calculation.json";
import rateVsConcentrationJson from "./rate-vs-concentration.json";
import thermalDecompCaco3Json from "./thermal-decomp-caco3.json";
import mgCombustionJson from "./mg-combustion.json";
import kclo3CatalysisJson from "./kclo3-catalysis.json";
import sodiumInWaterJson from "./sodium-in-water.json";
import potassiumInWaterJson from "./potassium-in-water.json";
import aluminumDisplacesCopperJson from "./aluminum-displaces-copper.json";
import quicklimeWaterJson from "./quicklime-water.json";
import bicarbonateVolcanoJson from "./bicarbonate-volcano.json";
import ammoniaHclSmokeJson from "./ammonia-hcl-smoke.json";
import copperAmmoniaTestJson from "./copper-ammonia-test.json";
import halogenDisplacementJson from "./halogen-displacement.json";
import silverAmmoniaTestJson from "./silver-ammonia-test.json";
import goldenRainJson from "./golden-rain.json";
import flameTestsJson from "./flame-tests.json";
import amphotericMgVsAlJson from "./amphoteric-mg-vs-al.json";
import leadChlorideTestJson from "./lead-chloride-test.json";
import calciumCarbonateTestJson from "./calcium-carbonate-test.json";
import halideBromideTestJson from "./halide-bromide-test.json";
import halideIodideTestJson from "./halide-iodide-test.json";
import bloodRedIronThiocyanateJson from "./blood-red-iron-thiocyanate.json";
import sulfideTestJson from "./sulfide-test.json";
import titrationGuidedJson from "./titration-guided.json";
import copperHydroxideAmmoniaDissolutionJson from "./copper-hydroxide-ammonia-dissolution.json";
import magnesiumHydroxidePrecipitationJson from "./magnesium-hydroxide-precipitation.json";
import znAcidFizzJson from "./zn-acid-fizz.json";
import nh3VsNaohAluminumJson from "./nh3-vs-naoh-aluminum.json";
import nh3IronPrecipitationJson from "./nh3-iron-precipitation.json";
import ammoniaBaseIndicatorJson from "./ammonia-base-indicator.json";
import kohExothermicJson from "./koh-exothermic.json";
import zincAmphotericAndComplexJson from "./zinc-amphoteric-and-complex.json";
import safetyHazardTourJson from "./safety-hazard-tour.json";
import dangerousMixDemoJson from "./dangerous-mix-demo.json";
import extinguisherDrillJson from "./extinguisher-drill.json";
import mixLabelDemoJson from "./mix-label-demo.json";
import peroxideDecayWatchJson from "./peroxide-decay-watch.json";
import overflowWarningJson from "./overflow-warning.json";
import copperZincDisplacementJson from "./copper-zinc-displacement.json";
import ironRustWatchJson from "./iron-rust-watch.json";
import limewaterCo2TestJson from "./limewater-co2-test.json";
import alcoholFlameTestJson from "./alcohol-flame-test.json";
import fermentationWatchJson from "./fermentation-watch.json";
import ethanolOxidationJson from "./ethanol-oxidation.json";
import organicSafetyTourJson from "./organic-safety-tour.json";
import electrolysisWaterHofmannJson from "./electrolysis-water-hofmann.json";
import electrolysisChloralkaliJson from "./electrolysis-chloralkali.json";
import electrolysisCuElectroplatingJson from "./electrolysis-cu-electroplating.json";
import galvanicDaniellJson from "./galvanic-daniell.json";
import galvanicDaniellFromPartsJson from "./galvanic-daniell-from-parts.json";
import electrolysisKbrAqueousJson from "./electrolysis-kbr-aqueous.json";
import titrationWithHeatingJson from "./titration-with-heating.json";
import vaporPressureExplosionJson from "./vapor-pressure-explosion.json";
import spatulaWeighingJson from "./spatula-weighing.json";
import phQuickSurveyJson from "./ph-quick-survey.json";
import gasCollectionDisplacementJson from "./gas-collection-displacement.json";
/**
 * Registry of every scenario the chemistry domain ships (session 177).
 * The order here is the order they appear in the lessons menu —
 * roughly easy → hard so the lobby reads as a curriculum.
 *
 * Adding a new lesson: drop a JSON next to this file, import it
 * here, push it to `chemistryScenarios`. No runtime fetch — Vite
 * inlines the JSON modules at build time.
 */
/** Resolve a scenario's `inheritFrom` by prepending instances from the
 *  named parent scenario. Local instances win on id collision. Used so
 *  the lab-tour can show every cabinet item + safety fixture without
 *  duplicating ~130 entries in its own JSON. */
function loadWithInheritance(json, pool) {
    if (!json.inheritFrom)
        return loadScenario(json);
    const parent = pool[json.inheritFrom];
    if (!parent) {
        console.warn(`scenario ${json.id}: inheritFrom "${json.inheritFrom}" not found`);
        return loadScenario(json);
    }
    const localIds = new Set(json.instances.map((i) => i.id));
    const merged = [
        ...parent.instances.filter((i) => !localIds.has(i.id)),
        ...json.instances
    ];
    return loadScenario({ ...json, instances: merged });
}
const inheritancePool = {
    "chemistry/sandbox": sandboxJson
};
export const chemistryScenarios = [
    loadWithInheritance(labTourJson, inheritancePool),
    loadScenario(howThisLabWorksJson),
    loadScenario(readingTheCloudJson),
    loadScenario(readingCuesJson),
    loadScenario(readingInfoPanelJson),
    loadScenario(summonAndBenchRulesJson),
    loadScenario(moleculeViewerTourJson),
    loadScenario(reactionRulesQuickJudgmentJson),
    loadScenario(reactionRulesPrecipitationJson),
    loadScenario(reactionRulesGasEvolutionJson),
    loadScenario(reactionRulesDisplacementJson),
    loadScenario(reactionRulesComplexJson),
    loadScenario(reactionRulesAmphotericJson),
    loadScenario(reactionRulesRedoxJson),
    loadScenario(reactionRulesDecompositionJson),
    loadScenario(gasTestsJson),
    loadScenario(gasPlumbingDemoJson),
    loadScenario(gasCylinderCl2KiJson),
    loadScenario(naohHandlingJson),
    loadScenario(safetyHazardTourJson),
    loadScenario(dangerousMixDemoJson),
    loadScenario(extinguisherDrillJson),
    loadScenario(mixLabelDemoJson),
    loadScenario(peroxideDecayWatchJson),
    loadScenario(overflowWarningJson),
    loadScenario(sandboxJson),
    loadScenario(dissolvingSaltJson),
    loadScenario(colorMixingJson),
    loadScenario(evaporationJson),
    loadScenario(dilutionJson),
    loadScenario(naohExothermicJson),
    loadScenario(kohExothermicJson),
    loadScenario(nh4no3EndothermicJson),
    loadScenario(carbonateAcidJson),
    loadScenario(titrationGuidedJson),
    loadScenario(titrationHclNaohJson),
    loadScenario(mgAcidFizzJson),
    loadScenario(znAcidFizzJson),
    loadScenario(halideTestJson),
    loadScenario(singleReplacementZnCuJson),
    loadScenario(copperHydroxidePrecipitationJson),
    loadScenario(magnesiumHydroxidePrecipitationJson),
    loadScenario(ironHydroxidePrecipitationJson),
    loadScenario(h2o2DecompositionJson),
    loadScenario(pbi2PrecipitationJson),
    loadScenario(mgH2so4Json),
    loadScenario(bariumSulfatePrecipitationJson),
    loadScenario(copperSilverTreeJson),
    loadScenario(acidBaseNeutralizationJson),
    loadScenario(stoichiometryMgHclJson),
    loadScenario(massBalanceCuAgJson),
    loadScenario(equilibriumFeScnJson),
    loadScenario(weakVsStrongAcidJson),
    loadScenario(commonIonEffectJson),
    loadScenario(bufferDemoJson),
    loadScenario(redoxTitrationPermanganateJson),
    loadScenario(catalysisH2o2Mno2Json),
    loadScenario(chromateDichromateJson),
    loadScenario(indicatorsComparisonJson),
    loadScenario(ammoniaBaseIndicatorJson),
    loadScenario(limitingReagentMgHclJson),
    loadScenario(singleReplacementFeCuJson),
    loadScenario(reactivitySeriesJson),
    loadScenario(dilutionCalculationJson),
    loadScenario(rateVsConcentrationJson),
    loadScenario(thermalDecompCaco3Json),
    loadScenario(mgCombustionJson),
    loadScenario(kclo3CatalysisJson),
    loadScenario(sodiumInWaterJson),
    loadScenario(potassiumInWaterJson),
    loadScenario(aluminumDisplacesCopperJson),
    loadScenario(quicklimeWaterJson),
    loadScenario(bicarbonateVolcanoJson),
    loadScenario(ammoniaHclSmokeJson),
    loadScenario(copperAmmoniaTestJson),
    loadScenario(copperHydroxideAmmoniaDissolutionJson),
    loadScenario(nh3VsNaohAluminumJson),
    loadScenario(nh3IronPrecipitationJson),
    loadScenario(zincAmphotericAndComplexJson),
    loadScenario(halogenDisplacementJson),
    loadScenario(silverAmmoniaTestJson),
    loadScenario(goldenRainJson),
    loadScenario(flameTestsJson),
    loadScenario(amphotericMgVsAlJson),
    loadScenario(leadChlorideTestJson),
    loadScenario(calciumCarbonateTestJson),
    loadScenario(halideBromideTestJson),
    loadScenario(halideIodideTestJson),
    loadScenario(bloodRedIronThiocyanateJson),
    loadScenario(sulfideTestJson),
    loadScenario(copperZincDisplacementJson),
    loadScenario(ironRustWatchJson),
    loadScenario(limewaterCo2TestJson),
    loadScenario(alcoholFlameTestJson),
    loadScenario(fermentationWatchJson),
    loadScenario(ethanolOxidationJson),
    loadScenario(organicSafetyTourJson),
    loadScenario(electrolysisWaterHofmannJson),
    loadScenario(electrolysisChloralkaliJson),
    loadScenario(electrolysisCuElectroplatingJson),
    loadScenario(galvanicDaniellJson),
    loadScenario(galvanicDaniellFromPartsJson),
    loadScenario(electrolysisKbrAqueousJson),
    loadScenario(titrationWithHeatingJson),
    loadScenario(vaporPressureExplosionJson),
    loadScenario(spatulaWeighingJson),
    loadScenario(phQuickSurveyJson),
    loadScenario(gasCollectionDisplacementJson)
];
